import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef } from 'react';

var FlexibleTextArea = function FlexibleTextArea(props) {
  var _props$input, _props$input2;

  var textField = useRef(null);

  var _calculateSize = function _calculateSize() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      /**
       * @type {HTMLTextAreaElement} element
       */
      var element = textField.current;
      var rows = element.textContent.split('\n').length - 1;

      if (rows < 0) {
        rows = 0;
      }

      element.style.height = 63 + 23 * rows + "px";
    }
  };

  var _onBlur = function _onBlur() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      var element = textField.current;
      element.classList.remove('focus');
    }

    _calculateSize(); // Animation timing


    setTimeout(function () {
      return _calculateSize();
    }, 150);
  };

  var _onFocus = function _onFocus() {
    if ((textField === null || textField === void 0 ? void 0 : textField.current) != null) {
      var element = textField.current;
      element.classList.add('focus');
    }

    _calculateSize(); // Animation timing


    setTimeout(function () {
      return _calculateSize();
    }, 150);
  };

  useEffect(function () {
    _calculateSize();
  }, [props.children]);

  var elementProps = _objectSpread({}, props);

  delete elementProps.style;
  delete elementProps.children;
  delete elementProps.input;
  delete elementProps.meta;
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: "transition--fast",
    ref: textField,
    onKeyUp: _calculateSize,
    onBlur: _onBlur,
    onFocus: _onFocus,
    onChange: (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.onChange,
    value: (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.value,
    style: _objectSpread({
      resize: 'inherit',
      maxHeight: '109px'
    }, props.style)
  }, elementProps), props.children);
};

export default FlexibleTextArea;